import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import ServicesPage from './pages/ServicesPage'
import ServiceDetailPage from './pages/ServiceDetailPage'
import AboutPage from './pages/AboutPage'
import ReviewsPage from './pages/ReviewsPage'
import ContactPage from './pages/ContactPage'
import AccountingHelpPage from './pages/AccountingHelpPage'
import BookkeepingPage from './pages/BookkeepingPage'
import AnnualReportPage from './pages/AnnualReportPage'
import PricingPage from './pages/PricingPage'

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-stone-50 text-stone-800 antialiased selection:bg-orange-600 selection:text-white">
      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Global Navigation */}
      <Navbar />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ydelser" element={<ServicesPage />} />
          <Route path="/ydelser/:slug" element={<ServiceDetailPage />} />
          <Route path="/priser" element={<PricingPage />} />
          <Route path="/pris" element={<PricingPage />} />
          <Route path="/om-os" element={<AboutPage />} />
          <Route path="/kunderne-siger" element={<ReviewsPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/regnskabsservice" element={<AccountingHelpPage />} />
          <Route path="/fa-hjaelp-til-regnskab" element={<AccountingHelpPage />} />
          <Route path="/aarsregnskab-og-bogfoering" element={<AccountingHelpPage />} />
          <Route path="/bogfoering" element={<BookkeepingPage />} />
          <Route path="/hjaelp-til-bogfoering" element={<BookkeepingPage />} />
          <Route path="/aarsrapport-og-aarsregnskab" element={<AnnualReportPage />} />
          <Route path="/aarsregnskab-og-aarsafslutning" element={<AnnualReportPage />} />
          <Route path="/aarsrapport" element={<AnnualReportPage />} />
          <Route path="/aarsregnskab" element={<AnnualReportPage />} />
          {/* Fallback route */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      {/* Global Footer */}
      <Footer />
    </div>
  )
}

export default App
